module.exports = __webpack_public_path__ + "img/num2_joy.6f7cf786.png";